module.exports = __webpack_public_path__ + "static/media/Home-Active.cab37875.svg";